import {sprintf} from "sprintf-js";

function filterMasterManifest(manifest) {
    const lines = manifest.split('\n');
    let maxBw = -1;
    let maxBwIndex = -1;

    // First pass: find max bandwidth
    for (let i = 0; i < lines.length; i++) {
        if (lines[i].startsWith('#EXT-X-STREAM-INF')) {
            const bwMatch = lines[i].match(/BANDWIDTH=(\d+)/);
            if (bwMatch) {
                const bw = parseInt(bwMatch[1], 10);
                if (bw > maxBw) {
                    maxBw = bw;
                    maxBwIndex = i;
                }
            }
        }
    }

    if (maxBwIndex === -1) return manifest;

    const newLines = [];
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        if (line.startsWith('#EXT-X-STREAM-INF')) {
            // Only keep the stream with the highest bandwidth
            if (i === maxBwIndex) {
                newLines.push(line);
                // The next line is the URI, include it as well
                if (i + 1 < lines.length) {
                    newLines.push(lines[i+1]);
                }
            }
            i++; // Skip the URI line for all streams (we added it manually above if matched)
        } else if (line.trim() !== '') {
            // Keep headers, audio groups, etc.
            newLines.push(line);
        }
    }
    const baseManifest = newLines.join('\n') + '\n';

    console.log('Base manifest', baseManifest);

    return baseManifest;
}

export function constructManifest(minManifest, url) {
    let mObj;
    try {
        mObj = JSON.parse(minManifest);
    } catch (e) {
        // If it's not JSON, it might be a Master Playlist that needs filtering
        if (typeof minManifest === 'string' && minManifest.includes('#EXT-X-STREAM-INF')) {
            return filterMasterManifest(minManifest);
        }
        return minManifest;
    }

    if (mObj.type === 'EVENT') {
        const segmentIntervals = mObj['si'].split(':');
        const extras = mObj['sme'].split('$');
        const isLive = mObj['live'];
        const segmentTargetDuration = Math.ceil(mObj['smtd']);
        let segmentUrlPrefix = mObj['sup'];
        const segmentTemplate = mObj['smt'];
        const bw = mObj['bw']

        let manifest = '#EXTM3U\n#EXT-X-VERSION:3\n';
        if (segmentTargetDuration !== 0) {
            manifest += '#EXT-X-TARGETDURATION:' + segmentTargetDuration + '\n';
        }

        // Append EXT-X-MEDIA-SEQUENCE occurring before any segments
        for (let i = 0; i < extras.length; i++) {
            if (extras[i].startsWith('#EXT-X-MEDIA-SEQUENCE:') && extras[i].endsWith('@-1')) {
                manifest += extras[i].split('@')[0] + '\n';
                break;
            }
        }

        // Append #EXT-X-PROGRAM-DATE-TIME occurring before any segments
        for (let i = 0; i < extras.length; i++) {
            if (extras[i].startsWith('#EXT-X-PROGRAM-DATE-TIME:') && extras[i].endsWith('@-1')) {
                manifest += extras[i].split('@')[0] + '\n';
                break;
            }
        }

        // Append all segments
        if (segmentIntervals[0] !== '') {
            for (let i = 0; i < segmentIntervals.length; i++) {
                const s = /(\d*)-(\d*)@([\d.]*)[!]?([\d]*)/.exec(segmentIntervals[i]);
                const start = s[1] * 1
                const end = s[2] * 1
                const segmentDuration = s[3] / 1000
                const increment = s[4] === '' ? 1 : s[4] * 1; // Assume an increment of 1 between consecutive segments if not specified otherwise

                const f = '#EXTINF:%.5f\n%s' + segmentTemplate + '\n';
                const templatePlaceholders = (segmentTemplate.match(/%[^%]/g) || []).length;

                for (let segmentN = start; segmentN <= end; segmentN += increment) {
                    if (templatePlaceholders >= 2) {
                        manifest += sprintf(f, segmentDuration, segmentUrlPrefix, Math.ceil(bw / 1000), segmentN);
                    } else {
                        manifest += sprintf(f, segmentDuration, segmentUrlPrefix, segmentN);
                    }
                }
            }
        }

        // If not live append
        if (!isLive) {
            manifest += '#EXT-X-ENDLIST';
        }

        console.log('Segment manifest',
            manifest.substr(0, 100),
            manifest.substr(manifest.length-100, manifest.length)
        );

        // console.log('Segment manifest', manifest);

        return manifest;
    } else {
        console.error('We currently only support event manifests in minified format!');
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/js/include/MinHls.js